<template>
<div class="reschedule-setting">
  <v-overlay :value="loading" absolute>
    <v-progress-circular indeterminate size="64"/>
  </v-overlay>

  <!-- 標題與編輯按鈕同一行 -->
  <div class="d-flex justify-space-between align-center mb-4">
    <div class="section-title">
      <div class="bullet">改約限制設定</div>
    </div>
    <div class="edit-controls">
      <v-btn
        v-if="!isEditing"
        outlined
        color="primary"
        class="rounded-lg"
        @click="startEditing"
      >
        <v-icon left small>mdi-pencil</v-icon>
        {{ $t('GENERAL.edit') }}
      </v-btn>
      <template v-else>
        <v-btn
          text
          class="mr-2 rounded-lg"
          @click="cancelEditing"
        >
          {{ $t('GENERAL.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          class="rounded-lg"
          @click="saveSettings"
        >
          {{ $t('GENERAL.save') }}
        </v-btn>
      </template>
    </div>
  </div>

  <!-- 內容區 -->
  <div class="setting-content pl-4">
      <!-- 唯讀狀態 -->
      <div v-if="!isEditing" class="text-body-2 py-2">
        {{ cancellationPeriodLabel }}
      </div>
      <!-- 編輯狀態 -->
      <v-radio-group
        v-else
        v-model="editableCancellationPeriod"
        row
        hide-details
        dense
        class="mt-0"
      >
        <v-radio label="24小時內不可改約" value="24"/>
        <v-radio label="8小時內不可改約" value="8"/>
        <v-radio label="隨時可改約" value="0"/>
      </v-radio-group>
  </div>
</div>
</template>

<script>
import { getRescheduleSettingsAPI, updateRescheduleSettingsAPI } from "../../api";
import { mapGetters } from "vuex";

export default {
  name: "RescheduleSetting",

  data() {
    return {
      loading: false,
      isEditing: false,
      // 原始資料（用於取消時還原）
      originalCancellationPeriod: null,
      // 編輯中的資料
      editableCancellationPeriod: null
    }
  },

  computed: {
    ...mapGetters([
      'axiosParamData',
    ]),
    cancellationPeriodLabel() {
      const labels = {
        '24': '24小時內不可改約',
        '8': '8小時內不可改約',
        '0': '隨時可改約'
      }
      return labels[this.editableCancellationPeriod] || ''
    }
  },

  mounted() {
    this.getSettings()
  },

  methods: {
    getSettings() {
      this.loading = true
      getRescheduleSettingsAPI(this.axiosParamData).then(res => {
        this.editableCancellationPeriod = res.data.cancellation_period
        this.originalCancellationPeriod = res.data.cancellation_period
      }).finally(() => {
        this.loading = false
      })
    },
    startEditing() {
      this.originalCancellationPeriod = this.editableCancellationPeriod
      this.isEditing = true
    },
    cancelEditing() {
      this.editableCancellationPeriod = this.originalCancellationPeriod
      this.isEditing = false
    },
    saveSettings() {
      this.loading = true
      const data = {
        ...this.axiosParamData,
        cancellation_period: this.editableCancellationPeriod
      }
      updateRescheduleSettingsAPI(data).then(() => {
        this.originalCancellationPeriod = this.editableCancellationPeriod
        this.isEditing = false
      }).catch(e => {
        alert('更新失敗')
        console.error(e)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.reschedule-setting {
  position: relative;
}

.section-title {
  .bullet::before {
    content: "";
    background: var(--v-tiffany-10-base);
    padding-inline: 5px;
    height: 10px;
    margin-inline-end: 10px;
    display: inline-block;
  }
}

.edit-controls {
  flex-shrink: 0;
}
</style>
